module.exports = __webpack_public_path__ + "static/img/airoad_img2.ceb8e532.png";